module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/male_consulter_resolved-8ab8e8b1ba684bd8f1e6f46ef6e24921.png";